var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-title-bar-scroll-page',{ref:"container",attrs:{"title":"患者录入员工作台"}},[_c('div',[_c('Grid',{staticStyle:{"width":"100%","padding":"32px"},attrs:{"column-num":4,"image-array":_vm.functionItems},on:{"click":_vm.handleFuntionMenuClick}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }